/** Формат Y-m-d H:i для отображения вместо ISO-строки с таймзоной */
export function formatYmdHi(value) {
    if (value === null || value === undefined || value === "") return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    const h = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");
    return `${y}-${m}-${d} ${h}:${min}`;
}

/** Подпись к комментарию о рыбалке по start/end с API (пусто, если даты не заданы) */
export function formatSpotCommentPeriod(startTime, endTime) {
    const start = formatYmdHi(startTime);
    const end = formatYmdHi(endTime);
    if (start && end) return `Рыбалка с ${start} по ${end}`;
    if (start) return start;
    if (end) return end;
    return "";
}
